/**
 * PageLoader — Branded full-screen loading indicator shown as Suspense
 * fallback while lazy-loaded route chunks are being fetched.
 * Matches PropertyShop brand aesthetics (dark bg, brand accent, subtle motion).
 */
export const PageLoader = () => (
  <div
    data-testid="page-loader"
    className="flex items-center justify-center h-screen"
    style={{ background: 'var(--bg-primary)' }}
  >
    <div className="flex flex-col items-center gap-4">
      {/* Animated ring spinner */}
      <div className="relative w-10 h-10">
        <div
          className="absolute inset-0 rounded-full animate-spin"
          style={{
            border: '2.5px solid var(--border-color)',
            borderTopColor: 'var(--brand)',
          }}
        />
        <div
          className="absolute inset-[6px] rounded-full animate-spin"
          style={{
            border: '2px solid transparent',
            borderBottomColor: 'var(--brand-light)',
            animationDirection: 'reverse',
            animationDuration: '0.8s',
          }}
        />
      </div>
      {/* Pulsing text */}
      <span
        className="text-sm tracking-wide animate-pulse"
        style={{ color: 'var(--text-muted)' }}
      >
        Loading...
      </span>
    </div>
  </div>
);
